interface ShareGrant {
  weddingId: string;
  resourceType: string;
  resourceIds?: string[];
  accessLevel: string;
}

export function resolveEventAccess(
  user: { uid: string; isAnonymous: boolean } | null,
  event: { id: string; userId?: string } | null,
  grants: Array<ShareGrant | null>,
  resource: string
): 'view' | 'edit' | 'manage' | null {
  if (!event) return null;
  if (user && !user.isAnonymous && event.userId === user.uid) return 'manage';
  let result: 'view' | 'edit' | 'manage' | null = null;
  const ranks = { view: 0, edit: 1, manage: 2 };
  for (const grant of grants) {
    if (!grant || grant.weddingId !== event.id) continue;
    const includesResource = grant.resourceType === resource ||
      (grant.resourceType === 'tasks_and_guests' && ['tasks', 'guests'].includes(resource)) ||
      (grant.resourceType === 'custom' && grant.resourceIds?.includes(resource));
    if (!includesResource) continue;
    const level = grant.accessLevel === 'editor' ? 'edit' : grant.accessLevel === 'viewer' ? 'view' : grant.accessLevel;
    if (level !== 'view' && level !== 'edit' && level !== 'manage') continue;
    if (!result || ranks[level] > ranks[result]) result = level;
  }
  return result;
}
